import { userRoleApi as api } from './userRoleApi';
export const addTagTypes = ['UserRoles'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      getUserRoles: build.query<GetUserRolesApiResponse, GetUserRolesApiArg>({
        query: queryArg => ({
          url: `/userRoles`,
          params: {
            search: queryArg.search,
            offset: queryArg.offset,
            limit: queryArg.limit,
            sortby: queryArg.sortby,
            orderby: queryArg.orderby,
            userId: queryArg.userId
          }
        }),
        providesTags: ['UserRoles']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type GetUserRolesApiResponse = /** status 200 UserRoles found. */ {
  ok?: boolean;
  data?: UserRoles;
  message?: string;
};
export type GetUserRolesApiArg = {
  /** Search text */
  search?: string;
  /** offset for pagination */
  offset?: number;
  /** number of rows to fetch */
  limit?: number;
  /** sort */
  sortby?: string;
  /** order */
  orderby?: string;
  /** userId */
  userId?: string;
};
export type UserRoles = {
  count?: number;
  rows?: {
    id: string;
    status: string;
    roleName: string;
    createdBy: string;
    createdAt: string;
    updatedAt: string;
  }[];
};
export const { useGetUserRolesQuery } = injectedRtkApi;
